import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString, Fragment, renderList, createVNode, unref, withCtx, createCommentVNode } from "vue";
import { CdrButton, IconSearch } from "@rei/cedar";
const _hoisted_1 = {
  key: 0,
  class: "related-links",
  "aria-labelledby": "related-links-heading",
  "data-ui": "related-links"
};
const _hoisted_2 = {
  id: "related-links-heading",
  tag: "h2",
  class: "related-links__heading"
};
const _hoisted_3 = {
  class: "related-links__link-list"
};
const _hoisted_4 = {
  class: "related-links__link-text"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RelatedLinks",
  props: {
    heading: {},
    links: {}
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    function registerRelatedLinkClick(link, index, event) {
      emit("metricsClick", {
        linkName: `related search_${link.anchorText}`,
        link: link.link,
        event,
        clickData: {
          relatedSearchIndex: String(index)
        }
      });
    }
    return (_ctx, _cache) => {
      return _ctx.links.length ? (openBlock(), createElementBlock("nav", _hoisted_1, [createElementVNode("h2", _hoisted_2, toDisplayString(_ctx.heading), 1), createElementVNode("ul", _hoisted_3, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.links, (link, index) => {
        return openBlock(), createElementBlock("li", {
          key: index,
          class: "related-links__link-item"
        }, [createVNode(unref(CdrButton), {
          class: "related-links__link",
          href: link.link,
          tag: "a",
          modifier: "secondary",
          onClick: (event) => registerRelatedLinkClick(link, index, event)
        }, {
          default: withCtx(() => [createVNode(unref(IconSearch), {
            "inherit-color": "",
            class: "related-links__link-icon",
            size: "small"
          }), createElementVNode("span", _hoisted_4, toDisplayString(link.anchorText), 1)]),
          _: 2
        }, 1032, ["href", "onClick"])]);
      }), 128))])])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=RelatedLinks2.mjs.map
